export function formatPrice(price: number, currency: string = '£'): string {
  return `${currency} ${price.toLocaleString()}.00`;
}

export function formatItemCount(count: number, singular: string = 'Item', plural: string = 'Items'): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
